/**
 * Records opened from Cmd-K, newest first, kept in this browser per workspace
 * so the palette has something useful to show before anything is typed —
 * instantly, with no request. A convenience only: storage can be empty or
 * unavailable (private windows), and every read and write tolerates that.
 */
export interface RecentItem {
  kind: 'CLIENT' | 'CONTACT' | 'INVOICE' | 'SUBSCRIPTION';
  id: string;
  title: string;
  subtitle?: string | null;
  path: string;
}

const MAX_RECENT = 6;

function storageKey(): string | null {
  try {
    const tenantId = localStorage.getItem('selectedTenantId');
    return tenantId ? `revvly.cmdk.recent.${tenantId}` : null;
  } catch {
    return null;
  }
}

export function readRecentItems(): RecentItem[] {
  const key = storageKey();
  if (!key) return [];
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(key) ?? '[]');
    return Array.isArray(parsed) ? (parsed as RecentItem[]).slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

export function rememberRecentItem(item: RecentItem): void {
  const key = storageKey();
  if (!key) return;
  try {
    const next = [
      item,
      ...readRecentItems().filter((r) => !(r.kind === item.kind && r.id === item.id)),
    ];
    localStorage.setItem(key, JSON.stringify(next.slice(0, MAX_RECENT)));
  } catch {
    // Storage full or blocked: the palette simply shows no recents.
  }
}
